var _rect, _mask, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionNauticalChartsColored({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    fill: "#73CBEF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_2319_8851",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 15,
    height: 16,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4,
    y: 4,
    width: 15,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5C15 6.10457 14.1046 7 13 7H11V9C11 9.55228 10.5523 10 10 10H8V12H14C14.5523 12 15 12.4477 15 13V16H16C17.1046 16 18 16.8954 18 18V19H11V18C9.89543 18 9 17.1046 9 16V15L5 11V5H15Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5C15 6.10457 14.1046 7 13 7H11V9C11 9.55228 10.5523 10 10 10H8V12H14C14.5523 12 15 12.4477 15 13V16H16C17.1046 16 18 16.8954 18 18V19H11V18C9.89543 18 9 17.1046 9 16V15L5 11V5H15Z",
    fill: "#FFFA66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H16V4H15V5ZM11 7V6H10V7H11ZM8 10V9H7V10H8ZM8 12H7V13H8V12ZM15 16H14V17H15V16ZM18 19V20H19V19H18ZM11 19H10V20H11V19ZM11 18H12V17H11V18ZM9 15H10V14.5858L9.70711 14.2929L9 15ZM5 11H4V11.4142L4.29289 11.7071L5 11ZM5 5V4H4V5H5ZM15 5H14C14 5.55228 13.5523 6 13 6V7V8C14.6569 8 16 6.65685 16 5H15ZM13 7V6H11V7V8H13V7ZM11 7H10V9H11H12V7H11ZM11 9H10V10V11C11.1046 11 12 10.1046 12 9H11ZM10 10V9H8V10V11H10V10ZM8 10H7V12H8H9V10H8ZM8 12V13H14V12V11H8V12ZM14 12V13H15H16C16 11.8954 15.1046 11 14 11V12ZM15 13H14V16H15H16V13H15ZM15 16V17H16V16V15H15V16ZM16 16V17C16.5523 17 17 17.4477 17 18H18H19C19 16.3431 17.6569 15 16 15V16ZM18 18H17V19H18H19V18H18ZM18 19V18H11V19V20H18V19ZM11 19H12V18H11H10V19H11ZM11 18V17C10.4477 17 10 16.5523 10 16H9H8C8 17.6569 9.34315 19 11 19V18ZM9 16H10V15H9H8V16H9ZM9 15L9.70711 14.2929L5.70711 10.2929L5 11L4.29289 11.7071L8.29289 15.7071L9 15ZM5 11H6V5H5H4V11H5ZM5 5V6H15V5V4H5V5Z",
    fill: "black",
    fillOpacity: 0.08,
    mask: "url(#path-2-outside-1_2319_8851)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1,
    stroke: "#5714CC",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionNauticalChartsColored);
export default __webpack_public_path__ + "static/media/ic_action_nautical_charts_colored.8144d263e7901186846cb54742ee6469.svg";
export { ForwardRef as ReactComponent };